import gql from 'graphql-tag'

export default gql`
	mutation updateProductAddition($id: ID!, $fields: ProductAdditionInput) {
		cashAssist {
			updateProductAddition(id: $id, fields: $fields) {
				id
				name
				variants
			}
		}
	}
`
